<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
<div layout="column" ui-view>
  <div layout="row" layout-align="space-around center" layout-padding>
    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"
          layout-align="space-around center">
     
      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.iniDate"
                     md-placeholder="{{'INI_DATE' | translate}}" md-min-date="vm.currentSeason.iniDate"
                     md-max-date="vm.endDate"></md-datepicker>
      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"
                     md-placeholder="{{'END_DATE' | translate}}" md-min-date="vm.iniDate"
                     md-max-date="vm.currentSeason.endDate"
                     ng-disabled="vm.iniDate === null"></md-datepicker>
      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{'FILTER' |
        translate}}
      </md-button>
    </form>
    
  </div>



   

    <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">
    <md-card flex-gt-md="80" flex="100">

      <div class="md-whiteframe-1dp" flex>
             <md-button ng-click="exportToExcel('#table1')">
                 <md-icon md-svg-src = '../../images/notebook.svg'></md-icon>
            </md-button> 
        <md-card-header layout-padding>
          <md-card-header-text>
            <span class="md-headline">Partits arbitrats</span> 
          </md-card-header-text>
        </md-card-header>
      </div>
      <md-card-content>
        <md-table-container>
          <table  md-table ng-model="vm.selected"  id="table1" >
            <thead md-head md-order="vm.query.order">
                
                
            <tr md-row ng-hide="!vm.filteredList.length">
                <th></th>
             <th md-column md-order-by="numinvoice"><span class="md-title">Num.Factura</span></th>
              <th md-column md-order-by="fecha"><span class="md-title">Data</span></th>
               <th md-column md-order-by="fechafact"><span class="md-title">Data Factura</span></th>
              <th md-column md-order-by="cognom1"><span class="md-title">Cognom 1</span></th>
               <th md-column md-order-by="cognom2"><span class="md-title">Cognom 2</span></th>
                <th md-column md-order-by="nom"><span class="md-title">Nom</span></th>
             
              <th md-column show-gt-xs hide><span class="md-title">DNI</span></th>
              <th md-column show-gt-xs hide><span class="md-title">Adreça</span></th>
               <th md-column show-gt-xs hide><span class="md-title">Municipi</span></th>
             <th md-column show-gt-xs hide><span class="md-title">Base</span></th>
                 <th md-column show-gt-xs hide><span class="md-title">Retenció IRPF</span></th>
                   <th md-column show-gt-xs hide><span class="md-title">Total</span></th>
                      <th md-column md-order-by="receptor"><span class="md-title">Receptor</span></th>
               
            </tr>
            </thead>
            <tbody md-body>
            <tr md-row md-select="vm.select"
                ng-repeat="persona in vm.filteredList = (vm.llistatpersones | filter:searchText ) | orderBy: vm.query.order">
             
            <td md-cell><md-checkbox ng-model="persona.selected" aria-label="license" ng-click="vm.enable()"></md-checkbox></td>
                   <td md-cell><span class="md-body-2">{{ persona.numinvoice }} </span></td>
                   <td md-cell><span class="md-body-2">{{ persona.fecha }} </span></td>
                 <td md-cell><span class="md-body-2">{{ persona.fechafact }} </span></td>
                 <td md-cell><span class="md-body-2">{{ persona.cognom1 }} </span></td>
                 <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.cognom2 }}</span></td>
              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.nom }}</span></td>
          
            <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.dni }}</span></td>
             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.adress}}</span></td>
             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.municipi}}</span></td>
              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.base}}</span></td>
             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.irpf }}</span></td>
              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.total }}</span></td>
                         <td md-cell><span class="md-body-2">{{ persona.receptor }} </span></td>
            </tr>
            </tbody>
          </table>
        </md-table-container>
        <span class="md-body-2" ng-hide="vm.filteredList.length"> No s'han trobat dades </span>
      </md-card-content>
    </md-card>
</div>
     <md-button class="md-fab md-accent md-fab-bottom-right" ng-click="vm.imprimir()" ng-disabled="vm.dis">
            <md-icon md-svg-src="images/ic_print_black_24px.svg" class="s24"
                     aria-label="Imprimir factures"></md-icon>
            <md-tooltip md-delay="50" md-direction="left">Imprimir factures</md-tooltip>
          </md-button>
</div>
            <div>
 
</div>
<div ng-hide="true">
 <neo-print-invoice-template id="invoicePrintPreview" ng-hide="true" persona="vm.persona"></neo-print-invoice-template>
</div>